import axios from "axios";

//const
const EQUIPMENT_TYPE_LIST_UPDATE_DATA = "equipmentTypeList/EQUIPMENT_TYPE_LIST_UPDATE_DATA";
const EQUIPMENT_TYPE_LIST_STORE_EQUIPMENT_TYPES = "equipmentTypeList/EQUIPMENT_TYPE_LIST_STORE_EQUIPMENT_TYPES";
const EQUIPMENT_TYPE_LIST_STORE_SHOW_EQUIPMENT_TYPES = "equipmentTypeList/EQUIPMENT_TYPE_LIST_STORE_SHOW_EQUIPMENT_TYPES";
const EQUIPMENT_TYPE_LIST_TOGGLE_MODAL = "equipmentTypeList/EQUIPMENT_TYPE_LIST_TOGGLE_MODAL";
const EQUIPMENT_TYPE_LIST_TOGGLE_LOADING = "equipmentTypeList/EQUIPMENT_TYPE_LIST_TOGGLE_LOADING";

const EQUIPMENT_TYPE_LIST_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentType_EquipmentTypeList_modal_success_title";
const EQUIPMENT_TYPE_LIST_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentType_EquipmentTypeList_modal_fail_title";
const EQUIPMENT_TYPE_LIST_MODAL_DELETE_SUCCESS_CONTENT = "scenes_Equipment_EquipmentType_EquipmentTypeList_modal_deleteSuccess_content";
const EQUIPMENT_TYPE_LIST_MODAL_DELETE_FAIL_CONTENT = "scenes_Equipment_EquipmentType_EquipmentTypeList_modal_deleteFail_content";
const EQUIPMENT_TYPE_LIST_MODAL_OK_LABEL = "scenes_Equipment_EquipmentType_EquipmentTypeList_modal_OK_label";
const EQUIPMENT_TYPE_LIST_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentType_EquipmentTypeList_modal_cancel_label";

//reducer
export const equipmentTypeList = (state = {
  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  equipmentTypes: [],
  showEquipmentTypes: [],
  name: "",
  equipmentTypeId: "",
  selectedKey: "",
}, action) => {
  switch (action.type) {
    case EQUIPMENT_TYPE_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_TYPE_LIST_STORE_EQUIPMENT_TYPES:
      return {
        ...state,
        equipmentTypes: action.data,
        showEquipmentTypes: action.data,
        selectedKey: "",
      };
    case EQUIPMENT_TYPE_LIST_STORE_SHOW_EQUIPMENT_TYPES:
      return {
        ...state,
        showEquipmentTypes: action.data,
        selectedKey: "",
      };
    case EQUIPMENT_TYPE_LIST_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_TYPE_LIST_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};
/**
 * update data based
 */
export const updateEquipmentTypeData = (data) => {
  return {
    type: EQUIPMENT_TYPE_LIST_UPDATE_DATA,
    data: data
  }
};

/**
 * init equipment types
 */
export const initEquipmentTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-equipment/getEquipmentTypeList", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentTypes(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment types
 */
export const storeEquipmentTypes = (equipmentTypes) => {
  return {
    type: EQUIPMENT_TYPE_LIST_STORE_EQUIPMENT_TYPES,
    data: equipmentTypes
  }
};

/**
 * filter equipment types
 */
export const filterEquipmentType = (data) => (dispatch) => {
  let showEquipmentTypes = data.equipmentTypes.filter(equipmentType => {
    return equipmentType.name.indexOf(data.name) > -1
  });
  dispatch(storeShowEquipmentTypes(showEquipmentTypes));
};

/**
 * store show equipment types
 */
export const storeShowEquipmentTypes = (equipmentTypes) => {
  return {
    type: EQUIPMENT_TYPE_LIST_STORE_SHOW_EQUIPMENT_TYPES,
    data: equipmentTypes
  }
};

/**
 * delete equipment type
 */
export const deleteEquipmentType = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-equipment/deleteEquipmentType/${data.id}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success delete equipment type");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_TYPE_LIST_MODAL_SUCCESS_TITLE,
          modalContent: EQUIPMENT_TYPE_LIST_MODAL_DELETE_SUCCESS_CONTENT,
          modalOk: EQUIPMENT_TYPE_LIST_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_TYPE_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(initEquipmentTypes());
            dispatch(toggleModal({modalVisible: false}))
          },
          onCancel: () => {
            dispatch(initEquipmentTypes());
            dispatch(toggleModal({modalVisible: false}))
          }
        }));
      } else {
        console.error("fail to delete equipment type");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_TYPE_LIST_MODAL_FAIL_TITLE,
          modalContent: EQUIPMENT_TYPE_LIST_MODAL_DELETE_FAIL_CONTENT,
          modalOk: EQUIPMENT_TYPE_LIST_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_TYPE_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({modalVisible: false}))
          },
          onCancel: () => {
            dispatch(toggleModal({modalVisible: false}))
          }
        }));
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_TYPE_LIST_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_TYPE_LIST_TOGGLE_LOADING,
    data: show
  }
};

